"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateAndConvert = validateAndConvert;
const FeatureAppInLayerParams_1 = require("../FeatureAppInLayerParams");
const LayerTypes_1 = require("./LayerTypes");
const validateAndConvertParams_1 = require("./validateAndConvertParams");
function validateAndConvert(params, urlParams, log) {
    if (!params.fa) {
        log.fail('no fa was specified');
        return;
    }
    if (!params.layer) {
        log.fail('no layer type was defined');
        return;
    }
    if (!isValidLayerType(params.layer)) {
        log.fail(`layer type ${params.layer} is invalid. Valid layer types are ${LayerTypes_1.LayerTypes.join(', ')}`);
        return;
    }
    const options = (0, validateAndConvertParams_1.validateAndConvertParams)(params, params.layer, log);
    if (options) {
        const extraParams = new URLSearchParams();
        if (urlParams) {
            urlParams.forEach((value, key) => {
                if (!FeatureAppInLayerParams_1.STANDARD_PROPS.includes(key)) {
                    extraParams.append(key, value);
                }
            });
        }
        return { options, extraParams };
    }
    return;
}
function isValidLayerType(layer) {
    return LayerTypes_1.LayerTypes.includes(layer);
}
//# sourceMappingURL=validateAndConvert.js.map